import type { Contact } from "../types";

function isBlank(value: string | null | undefined): boolean {
  if (value == null) {
    return true;
  }
  const trimmed = value.trim();
  return trimmed.length === 0 || trimmed.toLowerCase() === "null";
}

export function getContactDisplayName(
  contact: Pick<Contact, "first_name" | "last_name" | "company_name">,
): string {
  const parts = [contact.first_name, contact.last_name].filter(
    (part) => !isBlank(part),
  );
  if (parts.length > 0) {
    return parts.join(" ");
  }
  if (!isBlank(contact.company_name)) {
    return contact.company_name as string;
  }
  return "Sin nombre";
}

export function getContactPhone(
  contact: Pick<Contact, "phone_jsonb">,
): string | null {
  const first = contact.phone_jsonb?.find((entry) => entry.number);
  return first?.number ?? null;
}
